export const formatErrorMessage = (text) => {
  if (text?.includes('Unauthenticated: Bad credentials.')) {
    return 'Either your email or password is incorrect.';
  }
  if (text?.includes('The cart is frozen.')) {
    return 'Error Code 30: An unexpected error has occurred on your session. Please navigate back to your cart, review your items and try placing your order again.'
  }
  return text;
};

// we don't have any class or id
// so have to find backdrop via DOM
// after Recaptcha is rendered in forms
export const getRecaptchaBackdrop = (recaptchaBackdropRef, isMobile) => {
  if (!recaptchaBackdropRef || !window) return;

  if (!isMobile) {
    // mobile recaptcha
    const backdrop = document.querySelector(
      '.g-recaptcha-bubble-arrow',
    )?.previousElementSibling;
    if (backdrop) {
      recaptchaBackdropRef.current = backdrop;
    }
  } else {
    // desktop recaptcha
    const frames = document.querySelectorAll(
      'iframe[src*="https://recaptcha.net"]',
    );
    if (Array.from(frames).length) {
      const iframe = Array.from(frames).find((i) => i.title !== 'reCAPTCHA');
      const parentDiv = iframe?.parentNode;
      const backdrop = parentDiv?.previousSibling;
      if (backdrop) {
        recaptchaBackdropRef.current = backdrop;
      }
    }
  }

  if (!recaptchaBackdropRef.current)
    return setTimeout(
      () => getRecaptchaBackdrop(recaptchaBackdropRef, isMobile),
      500,
    );
};
